import request from '@/utils/request'

//首页分类
export function getinit(data) {
  return request({
    url:'index/index1',
    method:'post',
    data
  })
}
//留言
export function getsub(data) {
  return request({
    url:'index/message',
    method:'post',
    data
  })
}
//热搜关键字
export function getHot(data) {
  return request({
    url:'Goods/hot_keyword',
    method:'post',
    data
  })
}
//文章详情
export function getnewsing(data) {
  return request({
    url:'Index/find_news',
    method:'post',
    data
  })
}
//文章suoyou
export function getnews(data) {
  return request({
    url:'Index/query_news',
    method:'post',
    data
  })
}

//特色购
export function getntesegou(data) {
  return request({
    url:'Index/query_fea',
    method:'post',
    data
  })
}
//企业定制
export function getCustom(data) {
  return request({
    url:'Custom/index',
    method:'post',
    data
  })
}
//企业定制列表
export function getCustomliebiao(data) {
  return request({
    url:'Custom/list_custom',
    method:'post',
    data
  })
}
//活动分类接口
export function getclass_tive(data) {
  return request({
    url:'Index/class_tive',
    method:'post',
    data
  })
}
//活动分类接口
export function getclass_tive1(data) {
  return request({
    url:'Index/query_sing_goods',
    method:'post',
    data
  })
}
//活动页面接口
export function gettice_index(data) {
  return request({
    url:'Index/tice_index',
    method:'post',
    data
  })
}
















// WEBPACK FOOTER //
// ./src/api/index.js